/*
  Дома портфеля для вкладки «Подсудность домов» (решение владельца 02.11.2026, вариант А).

  Страницы, отборы и счётчики считает сервер по всему портфелю (`GET /court-houses`): в
  ответе рядом со страницей - счётчики вкладок-состояний (`counts`) и перечни для
  отборов по участку и населённому пункту. Новый отбор - другой список, поэтому он
  начинается с первой страницы (`resetKey`), а `version` - «перечитай после действия» на
  той же странице.
*/

import { useCallback } from 'react'

import { api } from '../api/client.js'
import usePagedList from './usePagedList.js'

/* По 25 на странице - как в макете варианта А; размер, выбранный человеком, главнее. */
const PAGE_SIZE = 25

export const ALL = 'all'

export default function useCourtHouses({ q, court, settlement, state }, version) {
  const load = useCallback(
    (window) => {
      const params = { ...window }
      if (q) params.q = q
      if (court) params.court = court
      if (settlement) params.settlement = settlement
      if (state !== ALL) params.state = state
      return api.courtHouses(params)
    },
    // Версия входит в зависимости намеренно: её смена - это «перечитай».
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [q, court, settlement, state, version],
  )
  return usePagedList(load, PAGE_SIZE, 0, `${q}|${court}|${settlement}|${state}`)
}
